export const actionTileColors = [
	["#4285F4", "#00A8E8"],
	["#34A853", "#00A8A8"],
	["#FBBC05", "#F57C00"],
	["#EA4335", "#F9AB00"],
	["#7E57C2", "#4285F4"],
	["#00ACC1", "#34A853"],
];
